
import FormHelperText from "@mui/material/FormHelperText";
import { useId } from "react";
import styles from "../../styles/components/input.module.scss";
import { Box, TextField } from "@mui/material";


const CustomInput = (
// CustomInputWith_forwardRef 

  {
    error = false,
    autoFocus,
    label,
    value,
    onChange,
    helperText = "",
    placeholder = "",
    type,
    // startAdornment,
    // endAdornment,
    className="",
    defaultValue,
    onClick,
    disabled = false,
    onKeyPress,
    onKeyDown,
    onPaste,
    multiline,
    rows,
  }) => {
  const id = useId();

  return (

    <Box className={styles.input_style_wrap}>
      {/* <label>{label}</label> */}
      <TextField fullWidth autoFocus={autoFocus}
        error={error}
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        // startAdornment={startAdornment}
        // endAdornment={endAdornment}
        className={className}
        defaultValue={defaultValue} 
        onClick={onClick} 
        disabled={disabled} 
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        multiline={multiline}
        rows={rows} autoComplete="off"
      />
      {error && <FormHelperText className={styles.error_text}>{helperText}</FormHelperText>}
    </Box>
  );
};


export default CustomInput;
